import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M7 11V7a5 5 0 0 1 9.9-1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Unlock";
const Unlock = memo(themed(Icon));
export {
  Unlock
};
//# sourceMappingURL=unlock.js.map
